import axios from 'axios'
import { useMemo } from 'react'
import { useAppSelector } from '../../presentation/hooks/store-hooks'

export const useAxiosInstances = () => {
  const authState = useAppSelector((state) => state.auth)
  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: process.env.REACT_APP_BASE_URL
    })
  }, [])

  const axiosAuthInstance = useMemo(() => {
    return axios.create({
      headers: {
        Authorization: `Bearer ${authState.token}`
      },
      baseURL: process.env.REACT_APP_BASE_URL
    })
  }, [authState.token])
  return {
    axiosInstance,
    axiosAuthInstance
  }
}